
import { fork, } from 'redux-saga/effects';

// Sagas
import { getAgeGroups, } from './rankings';
import { getEntries, } from './entries';
import { getAffiliates, } from './affiliates';
import { getMedals, getMedalsFull } from './medals';
import { getSponsors, } from './sponsors';
import { getTournaments, getUpcomingTournaments, getPastTournaments, getUpcomingTournamentsAll, getTournamentSeasons } from './tournaments';
import { getQAS } from './qas';
import { getContactList } from './contactEmailList';
import { getAlumni } from './alumni';
import { getHotels, getHotelsBySeason } from './hotels';

export default function* rootSaga() {
  yield [
    fork(getAgeGroups),
    fork(getEntries),
    fork(getAffiliates),
    fork(getSponsors),
    fork(getTournaments),
    fork(getUpcomingTournaments),
    fork(getPastTournaments),
    fork(getMedals),
    fork(getMedalsFull),
    fork(getQAS),
    fork(getContactList),
    fork(getUpcomingTournamentsAll),
    fork(getTournamentSeasons),
    fork(getAlumni),
    fork(getHotels),
    fork(getHotelsBySeason)
  ]
}


// WEBPACK FOOTER //
// ./src/redux-sagas/sagas/root.js